import React from 'react';
import { Redirect } from 'react-router-dom';
import AppPaths from '../../AppPaths';
import HardwareFirstPickYourFi from '../../components/HardwareFirstPickYourFi/HardwareFirstPickYourFi';
import { QuizAutoOpen } from '../../components/ProductQuiz/QuizAutoOpen';
import useHardwareFirstShop from '../../hooks/useHardwareFirstShop';
import { useFlagsLoaded } from '../../lib/growthbook';

/**
 * `/shop` is the pick-your-fi landing page. It is a separate url from `/products` rather than a
 * second shape of it, so marketing can point campaigns at one or the other; `/products` keeps the
 * classic listing for everyone. Visitors the hardware-first arm does not cover land back there,
 * carrying their query string so utm and coupon params survive the hop.
 */
export default function Shop() {
  const shopEnabled = useHardwareFirstShop();
  // main's prerendered shop renders before the flags load, when only the US counts as enrolled; and
  // its router may not hold the address bar's query string yet
  const flagsLoaded = useFlagsLoaded();

  if (flagsLoaded && !shopEnabled) {
    return <Redirect to={{ pathname: AppPaths.ProductListingPage, search: window.location.search }} />;
  }

  return (
    <>
      <QuizAutoOpen />
      <HardwareFirstPickYourFi />
    </>
  );
}
